import { gql } from 'graphql-tag'
import { orderFieldsCMA } from './orderFieldsCMA'

export const GET_ORDERS_BY_TRACKING_IDS = gql`
  query getOrdersByTrackingIds($trackingIds: [String]!, $includePickups: Boolean = false) {
    orders: getOrdersByTrackingIds(trackingIds: $trackingIds, includePickups: $includePickups) {
      ...OrderFieldsCMA
    }
  }
  ${orderFieldsCMA}
`
